import { Atom } from '../../chem/struct'
import { fromAtomAddition, fromAtomsAttrs } from '../actions/atom'
function XGroupHeteroatomTool(editor) {
  if (!(this instanceof XGroupHeteroatomTool)) {
    editor.selection(null)
    return new XGroupHeteroatomTool(editor)
  }

  this.editor = editor
}

XGroupHeteroatomTool.prototype.mousemove = function (event) {
  this.editor.hover(this.editor.findItem(event, ['atoms']))
}

XGroupHeteroatomTool.prototype.click = function (event) {
  const rnd = this.editor.render
  const ci = this.editor.findItem(event, ['atoms'])

  if (!ci) {
    this.editor.hover(null)
    propsDialog(this.editor, null, rnd.page2obj(event))
    return true
  } else if (ci.map === 'atoms') {
    this.editor.hover(null)
    propsDialog(this.editor, ci.id)
    return true
  }
  return true
}

function propsDialog(editor, id, pos) {
  const struct = editor.render.ctab.molecule
  const atom = id || id === 0 ? struct.atoms.get(id) : null
  const xglabel = atom ? atom.xglabel : 0
  const label = atom ? atom.label : 'X#'

  const res = editor.event.elementEdit.dispatch({
    label: 'X#',
    xglabel,
    fragId: atom ? atom.fragment : null
  })

  Promise.resolve(res)
    .then(elem => {
      elem = Object.assign({}, Atom.attrlist, elem)
      if (!id && id !== 0 && elem.xglabel) {
        editor.update(fromAtomAddition(editor.render.ctab, pos, elem))
      } else if (xglabel !== elem.xglabel) {
        elem.aam = atom.aam // WTF??
        elem.attpnt = atom.attpnt
        if (!elem.xglabel && label !== 'X#') elem.label = label
        editor.update(fromAtomsAttrs(editor.render.ctab, id, elem))
      }
    })
    .catch(() => null) // w/o changes
}

export default XGroupHeteroatomTool
